import { query as stardogQuery } from 'stardog';

export type QueryType =
  | stardogQuery.QueryType
  | 'graphql'
  | 'explain'
  | 'profile'
  | 'shacl_report';
export enum QueryTypeIdentifier {
  SELECT = 'select',
  ASK = 'ask',
  CONSTRUCT = 'construct',
  DESCRIBE = 'describe',
  UPDATE = 'update',
  PATHS = 'paths',
  PROFILE = 'profile',
  GRAPHQL = 'graphql',
  EXPLAIN = 'explain',
  SHACL_REPORT = 'shacl_report',
  VALIDATE = 'validate',
}
